import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApi from "./hooks/useApi";

export const useUpdateCYAvailability = () => {
  const queryClient = useQueryClient();
  const { requestFn } = useApi<{
    message: string;
    availability: boolean;
  }>({
    url: "/codeYellowAvailability/update",
    method: "POST",
  });

  return useMutation({
    mutationFn: (data: { codeYellowId: string; userId: string; optIn: boolean }) =>
      requestFn(data),
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["codeYellowTargetedProvidersWithAvailability"],
        }),
        queryClient.invalidateQueries({ queryKey: ["myGroups", { role: "admin" }] }),
        queryClient.invalidateQueries({ queryKey: ["activeAdminCodeYellows"] }),
        queryClient.invalidateQueries({ queryKey: ["myActiveCodeYellows"] }),
        queryClient.invalidateQueries({ queryKey: ["myActiveTargetedCodeYellows"] }),
        queryClient.invalidateQueries({ queryKey: ["myScheduledTargetedCodeYellows"] }),
        queryClient.invalidateQueries({ queryKey: ["myScheduledCodeYellows"] }),
        queryClient.invalidateQueries({ queryKey: ["adminGroupCodeYellowRecords"] }),
        queryClient.invalidateQueries({ queryKey: ["groupedActiveAndScheduledCodeYellows"] }),
      ]);
    },
  });
};
